import { REDUCE_NOTES } from '../../constants/actions/policy';

export function reduceNotes(payload) {
    return {
        type: REDUCE_NOTES,
        payload,
    };
}
